module.exports = "/_next/static/images/commentCallbackIcon-44b17a0f21c2bd144aaf38788e31f092.svg";